import { useQuery } from "react-query";
import { fetchAvvReports } from "./api";

export function useAvvs(options={}) {
    return useQuery(["fetchAvvReports"], () => fetchAvvReports(), {
      staleTime: 0, 
      ...options
    })
  }